import React from 'react';
import { Route, Router, IndexRoute, IndexRedirect } from 'react-router';
import Utils from 'utils/utils';
import { setProfile } from 'redux/modules/user';
import callApi from 'helpers/callApi';
import Cookies from 'js-cookie';

import App from './App';
import Admin from './containers/Admin';
import Login from './containers/Login';
import NotFound from './NotFound';

import Page from './containers/Page';
import Category from './containers/Category';

//Class
import ClassList from './containers/Class/ClassList';
import ClassInfo from './containers/Class/ClassInfo';

// TEacher
import TeacherList from './containers/Teacher/TeacherList';
import TeacherInfo from './containers/Teacher/TeacherInfo';

// Order
import Order from './containers/Order/Order';
import OrderInfo from './containers/Order/OrderInfo';

import OrderItems from './containers/Order/OrderItemList';
import OrderItemInfo from './containers/Order/OrderItemInfo';

//Student
import StudentList from './containers/Student/StudentList';
import StudentInfo from './containers/Student/StudentInfo';

//Withdrawal
import Withdraw from './containers/Withdraw/Withdraw';
import WithdrawalInfo from './containers/Withdraw/WithdrawalInfo.js';

import PromocodeList from './containers/Promocode/PromocodeList';

import AdminList from './containers/AdminManagement/AdminList';

import PointList from './containers/Point/PointList';

import PaymentVouchers from './containers/PVRV/PaymentVouchers';
import ReceiptVouchers from './containers/PVRV/ReceiptVouchers';

import Province from './containers/Province/Province';

import RevenueSummary from './containers/PVRV/RevenueSummary';

import ScheduleList from './containers/Schedule/ScheduleList';
import ScheduleInfo from './containers/Schedule/ScheduleInfo';

// import {
//   App,
//   Admin,
//   Login,
//   Page,
//   Category,
//   Province,
//   NotFound,
//   /* Teacher */ TeacherList,
//   TeacherInfo,
//   TeacherRevenue,
//   /* Student */ StudentList,
//   StudentInfo,
//   /* Class */ ClassInfo,
//   ClassList,
//   ScheduleList,
//   ScheduleInfo,
//   OfferingScheduleInfo,
//   AdminList,
//   Order,
//   OrderInfo,
//   Withdraw,
//   WithdrawalInfo,
//   PaymentVouchers,
//   ReceiptVouchers,
//   RevenueSummary,
//   PointList,
//   // Booking, Order
//   // Register, InterestList
// } from 'containers';

export default (store) => {
  const hasToken = () => !!Utils.getToken();

  const requireLogin = async (nextState, replace, done, isRedirecting) => {
    const checkAuth = (me) => {
      console.log(store.getState().user);
      if (!me.email) {
        console.log('c');
        replace('/login');
        done();
      }

      done(isRedirecting);
    };
    if (!hasToken()) {
      console.log('b');
      replace('/login');
      done();
    } else if (!Utils.isAuth(store.getState().user)) {
      const verify = async () => {
        try {
          const me = await callApi({ url: '/users/me' });
          store.dispatch(setProfile(me));
          checkAuth(me);
        } catch (error) {
          console.log(error);
          // Cookies.remove('accessToken');
          console.log('d');
          // replace('/login');
          // window.location.reload();
        }
      };
      await verify();
    } else {
      console.log('a');
      replace('/login');
      done();
    }
  };
  return (
    <Route breadcrumbName="Home" path="/" component={App}>
      <IndexRedirect to="/page" />
      <Route path="login" component={Login} />
      <Route onEnter={requireLogin} component={Admin} breadcrumbName=" ">
        <Route breadcrumbName="Page" path="page" component={Page} />

        <Route path="category" breadcrumbName="Category" component={Category} />
        <Route path="order" breadcrumbName="Order">
          <IndexRoute breadcrumbName="" component={Order} />
          <Router path=":orderId" breadcrumbName=":orderId">
            <IndexRoute component={OrderInfo} breadcrumbName="" />
          </Router>
        </Route>
        <Route path="withdraw" breadcrumbName="Withdrawal">
          <IndexRoute breadcrumbName="" component={Withdraw} />
          <Router path=":withdrawalId" breadcrumbName=":withdrawalId">
            <IndexRoute component={WithdrawalInfo} breadcrumbName="" />
          </Router>
        </Route>

        <Router breadcrumbName="Class" path="class">
          <IndexRoute breadcrumbName="" component={ClassList} />
          <Router path=":classId" breadcrumbName=":classId">
            <IndexRoute component={ClassInfo} noLink={true} />
            <Router path="schedule" breadcrumbName="Schedule" replaceTo="?selectedTab=schedules" replaceFrom="/schedule">
              <Router path=":scheduleId" breadcrumbName=":scheduleId">
                <IndexRoute component={ScheduleInfo} noLink={true} breadcrumbName="" />
                {/* <Router path="offering" breadcrumbName="Timetable" noLink={true}>
                  <IndexRoute component={OfferingScheduleInfo} breadcrumbName="" noLink={true} />
                </Router> */}
              </Router>
            </Router>
          </Router>
        </Router>

        <Route path="teacher" breadcrumbName="Teacher">
          <IndexRoute breadcrumbName="ignoreTeacherList" component={TeacherList} />

          <Router path=":id" breadcrumbName=":id">
            <IndexRoute breadcrumbName="" component={TeacherInfo} />
          </Router>
        </Route>
        <Route path="student" breadcrumbName="Student">
          <IndexRoute breadcrumbName="" component={StudentList} />
          <Router path=":id" breadcrumbName=":id" component={StudentInfo} />
        </Route>
        <Route path="point" breadcrumbName="Point">
          <IndexRoute breadcrumbName="" component={PointList} />
        </Route>
        <Route path="promocode" breadcrumbName="Promocode">
          <IndexRoute breadcrumbName="" component={PromocodeList} />
        </Route>
        <Route path="admin" breadcrumbName="Student">
          <IndexRoute breadcrumbName="" component={AdminList} />
        </Route>
        <Route path="pv" breadcrumbName="Payment Voucher">
          <IndexRoute breadcrumbName="" component={PaymentVouchers} />
        </Route>
        <Route path="rv" breadcrumbName="Receipt Voucher">
          <IndexRoute breadcrumbName="" component={ReceiptVouchers} />
        </Route>

        <Route path="province" breadcrumbName="Province" component={Province} />
        <Route path="revenue-summary" breadcrumbName="Revenue Summary">
          <IndexRoute breadcrumbName="" component={RevenueSummary} />
        </Route>

        <Router breadcrumbName="Schedule" path="schedule">
          <IndexRoute breadcrumbName="" component={ScheduleList} />
          <Router path=":scheduleId" breadcrumbName=":scheduleId">
            <IndexRoute component={ScheduleInfo} breadcrumbName="" />
          </Router>
          {/* <Router path=":scheduleId/offering" breadcrumbName=":scheduleId">
            <IndexRoute component={OfferingScheduleInfo} breadcrumbName="" />
          </Router> */}
        </Router>

        <Route path="*" component={NotFound} status={404} />
      </Route>
    </Route>
  );
};
